<template>
  <div class="tv" @click="hideVideo">
    <section class="main">
      <!-- 顶部 banner 图 -->
      <div class="t_pic_box">
        <img class="t_pic" src="../assets/img/chestnut/banner3.jpg" alt />
      </div>
      <!-- 面包屑导航 -->
      <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>品牌「栗」史</el-breadcrumb-item>
          <el-breadcrumb-item>好产品 有「栗」量</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="develop">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              PRODUCT
              <br />PRESENTATION
            </div>
            <div class="title2">好产品 有「栗」量</div>
          </div>
        </div>
        <!-- 视频卡片列表：5 张等宽卡片纵向堆叠 -->
        <div class="d_list">
          <div
            class="v_card"
            v-for="item in videoList"
            :key="item.id"
          >
            <!-- 缩略图 + 播放按钮覆盖层 -->
            <div class="imgbox" @click.stop="play(item.id)">
              <img class="cover" :src="item.cover" :alt="item.title" />
              <!-- 悬停遮罩：渐变深色层，聚焦播放按钮 -->
              <div class="mask"></div>
              <!-- 播放按钮默认态 -->
              <div class="hover_no">
                <img src="../assets/img/tv/bt_play.png" alt="播放" />
              </div>
              <!-- 播放按钮悬停态 -->
              <div class="hovers">
                <img src="../assets/img/tv/bt_play_hover.png" alt="播放" />
              </div>
            </div>
            <!-- 标题面板（品牌黄底） -->
            <div class="v_pannel">
              <h3 class="tit">{{ item.title }}</h3>
            </div>
          </div>
        </div>
      </div>
      <!-- 视频播放弹窗：点击卡片展示，点击遮罩关闭 -->
      <div
        class="videobg"
        v-for="item in videoList"
        :key="'video-' + item.id"
        v-show="activeVideo === item.id"
      >
        <!-- 阻止点击视频本体（含原生控制条）冒泡触发关闭 -->
        <video controls="controls" :id="'video' + item.id" @click.stop>
          <source :src="item.src" type="video/mp4" />
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 当前播放的视频序号（null 表示无播放）
      activeVideo: null,
      // 视频卡片数据：静态常量，冻结后 Vue 不会为其建立响应式追踪，提升性能
      videoList: Object.freeze([
        { id: 1, title: '《好产地有「栗」量》板栗溯源之旅—燕山山脉板栗', cover: require('../assets/img/tv/thumb_chestnut_montage.png'), src: require('../assets/video/chestnut_montage.mp4') },
        { id: 2, title: '《好产地有「栗」量》瓜子溯源之旅—内蒙古363葵花籽', cover: require('../assets/img/tv/thumb_tribute_no2.jpg'), src: require('../assets/video/tribute_no2_origin.mp4') },
        { id: 3, title: '《好产地有「栗」量》山楂溯源之旅—东北大五棱山楂', cover: require('../assets/img/tv/thumb_hawthorn.jpg'), src: require('../assets/video/hawthorn_origin_tvc.mp4') },
        { id: 4, title: '《好产地有「栗」量》红薯溯源之旅—河北烟薯25', cover: require('../assets/img/tv/thumb_sweet_potato.jpg'), src: require('../assets/video/sweet_potato_origin.mp4') },
        { id: 5, title: '《好产地有「栗」量》花生溯源之旅—安徽巢湖小白沙花生', cover: require('../assets/img/tv/thumb_peanut.jpg'), src: require('../assets/video/peanut_origin_tvc.mp4') }
      ])
    };
  },
  methods: {
    // 播放指定序号的视频
    play(type) {
      this.activeVideo = type;
      // 等待 v-show 生效后再调用播放，避免 display:none 时播放失败
      this.$nextTick(() => {
        const video = document.getElementById(`video${type}`);
        if (!video) return;
        video.currentTime = 0;
        video.play();
      });
    },
    // 关闭弹窗并暂停所有视频，防止后台继续发声
    hideVideo() {
      this.activeVideo = null;
      this.videoList.forEach(item => {
        const video = document.getElementById(`video${item.id}`);
        if (video) video.pause();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tv {
  text-align: left;
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .bread {
    background: #fafafa;
  }
  .develop {
    // 响应式容器：最大宽度 1200px，两侧留白
    max-width: 1200px;
    width: 100%;
    margin: 80px auto 123px;
    padding: 0 20px;
    box-sizing: border-box;
    .top_title {
      position: relative;
      text-align: center;
      margin-bottom: 53px;
    }

    .top_title .title1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      font-family: 'HarmonyOS Sans SC';
      font-size: 60px;
      color: rgba(76, 1, 4, 0.05);
      line-height: 60px;
      text-align: center;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .top_title .title2 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 40px;
      color: #4c0104;
      text-align: center;
      font-weight: 500;
      width: 100%;
      margin-bottom: 85px;
      padding-top: 32px;
      position: relative;
      z-index: 1;
    }
    .d_list {
      // CSS Grid 多列布局：避免单卡独占一行导致展示过大
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      // 8px 网格：列间距与行间距统一 32px，节奏一致
      gap: 32px;
      .v_card {
        width: 100%;
        border-radius: 12px;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        transition: box-shadow 0.3s ease, transform 0.3s ease;
        // 悬停时上浮 + 加深阴影 + 缩略图放大，多维度强化可点击感知
        &:hover {
          box-shadow: 0 12px 32px rgba(76, 1, 4, 0.18);
          transform: translateY(-4px);
          .imgbox .cover {
            transform: scale(1.04);
          }
          .imgbox .mask {
            opacity: 1;
          }
        }
        .imgbox {
          position: relative;
          width: 100%;
          // 统一 16:9 画面比例，保证所有卡片等高且缩略图完整显示
          aspect-ratio: 16 / 9;
          overflow: hidden;
          cursor: pointer;
          .cover {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            // 配合卡片悬停做平滑放大过渡
            transition: transform 0.4s ease;
          }
          // 悬停遮罩：底部渐变深色层，默认透明，悬停淡入以聚焦播放按钮
          .mask {
            position: absolute;
            inset: 0;
            background: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.35) 100%
            );
            opacity: 0;
            transition: opacity 0.3s ease;
            pointer-events: none;
          }
          // 播放按钮默认态与悬停态，居中展示
          .hover_no,
          .hovers {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            // 用 opacity + scale 平滑切换，替代生硬的 display 切换
            transition: opacity 0.3s ease, transform 0.3s ease;
            img {
              display: block;
              // 多列布局下按钮尺寸收敛，避免遮挡过多画面
              width: 64px;
              height: 64px;
            }
          }
          // 默认态：显示 bt_play
          .hover_no {
            opacity: 1;
          }
          // 悬停态图标初始隐藏并缩小，悬停时显现且轻微放大
          .hovers {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.85);
          }
          &:hover .hover_no {
            opacity: 0;
          }
          &:hover .hovers {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1.08);
          }
        }
        // 标题面板：沿用品牌黄底配色
        .v_pannel {
          background: #ffe800;
          // 多列布局下内边距收敛，保持卡片紧凑
          padding: 16px 8px;
          .tit {
            font-family: PingFangSC-Regular;
            // 多列卡片主标题 20px，建立明确的信息层级
            font-size: 13px;
            // #1a1a1a 在 #ffe800 上对比度约 12:1，远超 WCAG AA 标准（4.5:1）
            color: #1a1a1a;
            font-weight: 500;
            line-height: 1.4;
            // 单行截断：过长标题以省略号收尾，避免撑高卡片破坏等高布局
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      // 响应式：中屏（≤1024px）2 列，字号与间距收敛
      @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        .v_card {
          .v_pannel {
            padding: 14px 18px;
            .tit {
              font-size: 18px;
            }
          }
        }
      }
      // 响应式：窄屏（≤767px）单列，保证移动端可读性与紧凑度
      @media (max-width: 767px) {
        grid-template-columns: 1fr;
        gap: 16px;
        .v_card {
          border-radius: 8px;
          .imgbox {
            .hover_no,
            .hovers {
              img {
                width: 56px;
                height: 56px;
              }
            }
          }
          .v_pannel {
            padding: 12px 16px;
            .tit {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
